import { DocumentsTypes } from './actionTypes';

export const getDocuments = (data: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS,
  payload: data,
});

export const getDocumentsSuccess = (data: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS_SUCCESS,
  payload: data,
});

export const getDocumentsFail = (error: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS_FAIL,
  payload: error,
});

export const getOneDocument = (data: any) => ({
  type: DocumentsTypes.GET_ONE_DOCUMENT,
  payload: data,
});

export const getOneDocumentSuccess = (data: any) => ({
  type: DocumentsTypes.GET_ONE_DOCUMENT_SUCCESS,
  payload: data,
});

export const getOneDocumentFail = (error: any) => ({
  type: DocumentsTypes.GET_ONE_DOCUMENT_FAIL,
  payload: error,
});

//---------------------------------------INNOBO DOCS----------------------------------------------------------
export const getDocumentsInnoboDocs = (data: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS_INNOBO_DOCS,
  payload: data,
});

export const getDocumentsSuccessInnoboDocs = (data: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS_SUCCESS_INNOBO_DOCS,
  payload: data,
});

export const getDocumentsFailInnoboDocs = (error: any) => ({
  type: DocumentsTypes.GET_DOCUMENTS_FAIL_INNOBO_DOCS,
  payload: error,
});

//--UPDATE--------

export const uploadDocumentInnoboDocs = (data: any) => ({
  type: DocumentsTypes.UPLOAD_DOCUMENT_INNOBO_DOCS,
  payload: data,
});

export const uploadDocumentSuccessInnoboDocs = (data: any) => ({
  type: DocumentsTypes.UPLOAD_DOCUMENT_SUCCESS_INNOBO_DOCS,
  payload: data,
});

export const uploadDocumentFailInnoboDocs = (error: any) => ({
  type: DocumentsTypes.UPLOAD_DOCUMENT_FAIL_INNOBO_DOCS,
  payload: error,
});

//--DELETE--------
export const deleteDocumentInnoboDocs = (data: any) => ({//data == lista de strings
  type: DocumentsTypes.DELETE_DOCUMENT_INNOBO_DOCS,
  payload: data,
});

export const deleteDocumentSuccessInnoboDocs = (data: any) => ({
  type: DocumentsTypes.DELETE_DOCUMENT_SUCCESS_INNOBO_DOCS,
  payload: data,
});

export const deleteDocumentFailInnoboDocs = (error: any) => ({
  type: DocumentsTypes.DELETE_DOCUMENT_FAIL_INNOBO_DOCS,
  payload: error,
});